import React from "react";

// IMPORT OTHERS HERE //
import { WebsiteIcon } from "assets/Images";
import appStyles from "./CertificationCard.module.scss";

const CertificationCard = (props) => {
  const { title, provider, platform, issueDate, credentialUrl, skills = [] } = props || {};

  const handleOpenCertificate = (e) => {
    e?.stopPropagation?.();
    if (credentialUrl) {
      window.open(credentialUrl, "_blank");
    }
  };

  return (
    <article className={appStyles.card}>
      <div className={appStyles.accentBar} />

      <header className={appStyles.headerRow}>
        <div className={appStyles.titleBlock}>
          <h3 className={appStyles.title}>{title}</h3>
          {provider ? (
            <div className={appStyles.providerLine}>
              <span className={appStyles.provider}>{provider}</span>
              {/* <span className={appStyles.dot}>•</span>
              <span className={appStyles.platform}>{platform}</span> */}
            </div>
          ) : null}
        </div>

        {issueDate ? (
          <div className={appStyles.dateBlock}>
            <span className={appStyles.dateLabel}>Issued</span>
            <span className={appStyles.dateValue}>{issueDate}</span>
          </div>
        ) : null}
      </header>

      {skills.length ? (
        <ul className={appStyles.skillsRow}>
          {skills.map((skill) => (
            <li key={skill} className={appStyles.skill}>
              {skill}
            </li>
          ))}
        </ul>
      ) : null}

      <footer className={appStyles.footerRow}>
        <div className={appStyles.metaText} />
        <button
          type="button"
          className={`${appStyles.viewBtn} ${credentialUrl ? "" : appStyles.viewBtnHidden}`}
          onClick={credentialUrl ? handleOpenCertificate : undefined}
        >
          <WebsiteIcon className={appStyles.viewIcon} />
          <span>View certificate</span>
        </button>
      </footer>
    </article>
  );
};

export default CertificationCard;
